// Sentry frontend init — graceful no-op when REACT_APP_SENTRY_DSN is absent.
import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    if (typeof console !== "undefined") {
      console.info("[Sentry] disabled (no REACT_APP_SENTRY_DSN)");
    }
    return false;
  }
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || "production",
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
  });
  return true;
}

export { Sentry };
